/** import external dependencies */
import 'jquery';
import 'lazysizes'
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import './vue/search/index'

import SearchForm from './components/SearchForm';
import Header from './components/header';
import Toggle from './components/toggler';
import setMinHeight from './components/minHeightMain';
import Form from './components/form';
import Accessibility from './components/Accessibility';
import CacheBusting from "./components/CacheBusting";
import Ripple from "./components/Ripple";
import KeyBoardEvents from "./components/KeyBoardEvents";
import Tooltips from "./components/Tooltips";
import Menu from "./components/Menu.js";
import scrollToElementByHash from "./components/scrollToElementByHash";


document.addEventListener( 'readystatechange', () => {
    if ( document.readyState === 'interactive' ) {
        setMinHeight();
    }
} );

window.addEventListener( 'DOMContentLoaded', () => {
    // `no-js` to `js`.
    document.documentElement.className = document.documentElement.className.replace( /\bno-js\b/, '\bjs\b' );

    // Search.init();
    Toggle.init();
    new Header();
    new Accessibility();
    new CacheBusting();
    new Ripple();

    const menu = new Menu();
    menu.init();

    new KeyBoardEvents();

    const sf = document?.getElementsByClassName( 'search-form' );
    if ( !! sf && sf.length > 0 ) {
        Array.from( sf )?.forEach( f => new SearchForm( f ) );
    }
} );

if ( typeof jQuery !== 'undefined' ) {
    jQuery( document ).on( 'gform_post_render', function ( event, form_id, current_page ) {

        const form = document.getElementById( 'gform_' + form_id );

        if ( !! form ) {
            new Form( form );

            const tooltips = form.getElementsByClassName( 'tooltip' );
            if ( !! tooltips && tooltips.length > 0 ) {
                // Loop through tooltips, currently only used within GravityForms.
                Array.from( tooltips ).forEach( tt => new Tooltips( tt ) );
            }
        }
    } );
}

// Check for a hashed URL on page load.
window.addEventListener( 'load', scrollToElementByHash );

// Update the offset when the hash changes (e.g., through anchor links)
window.addEventListener( 'hashchange', scrollToElementByHash );

let resizeTimer;
window.addEventListener( 'resize', function () {
    clearTimeout( resizeTimer );
    resizeTimer = setTimeout( () => setMinHeight(), 100 );
} );

window.addEventListener( 'orientationchange', setMinHeight );

